import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mechventComponent from './mechvent.component';

let mechventModule = angular.module('mechvent', [
  uiRouter
])

.component('mechvent', mechventComponent);

export default mechventModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/mechvent/mechvent.js